import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/contacto")({
  head: () => pageHead("contact", "es"),
  component: Contact,
});
